export default __webpack_public_path__ + "resources/icons/d412-de29.png";